import { handleActions } from "redux-actions";
import { setConverterOnEdition } from "../actions/actions";

export default handleActions(
  {
    [setConverterOnEdition]: (state, action) => {
      return action.payload;
    },
  },
  {}
);
